import Icon from '../components/Icon';

const ErrorFilled = Icon(
  'error-filled',
  <>
    <path
      fillRule="evenodd"
      d="M14.298 2.238a3.25 3.25 0 0 0-4.596 0L2.238 9.702a3.25 3.25 0 0 0 0 4.596l7.464 7.465a3.25 3.25 0 0 0 4.596 0l7.465-7.465a3.25 3.25 0 0 0 0-4.596zM12.75 8a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zM12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      clipRule="evenodd"
    />
  </>
);

export default ErrorFilled;
